import {
  FETCH_CONTENT_CARDS_REQUEST, FETCHING_CONTENT_CARDS_SUCCEEDED, FETCHING_CONTENT_CARDS_FAILED,
  INVALIDATE_CONTENT_CARDS,

  FETCH_CONTENT_CARD_REQUEST, FETCHING_CONTENT_CARD_SUCCEEDED, FETCHING_CONTENT_CARD_FAILED,
  INVALIDATE_CONTENT_CARD
} from "constants/actionTypes";

import buildUrl from 'build-url';
import axios from 'axios';

import { createAction } from "redux-actions";
import { put, takeEvery, call } from "redux-saga/effects";

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const CONTENT_CARD_BASE_URL = `${apiUrl}/api/2.0/content-cards`;

/**
 * ------------------------------------------------------------
 * Fetch content cards 
 * ------------------------------------------------------------
*/
export const fetchContentCards = createAction(FETCH_CONTENT_CARDS_REQUEST, (page, limit = 20) => {
  return {
    page: page,
    limit: limit
  }
});

const fetchContentCardsSucceeded = createAction(FETCHING_CONTENT_CARDS_SUCCEEDED, (response) => {
  return response;
});

const fetchContentCardsFailed = createAction(FETCHING_CONTENT_CARDS_FAILED, (error) => {
  return error;
});

function* fetchContentCardsSaga(action) {
  const { page, limit } = action.payload;

  const params = {
    page: page,
    limit: limit
  };

  let url = buildUrl(CONTENT_CARD_BASE_URL, {
    queryParams: params
  });

  const fetchContentCardsAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchContentCardsAPI);
    if (response) {
      yield put(fetchContentCardsSucceeded(response));
    }
  } catch (error) {
    yield put(fetchContentCardsFailed(error));
  }
}

/**
 * ------------------------------------------------------------
 * Invalidate Content cards
 * ------------------------------------------------------------
*/
export const invalidateContentCards = createAction(INVALIDATE_CONTENT_CARDS);

/**
 * ------------------------------------------------------------
 * Fetch Content card for {id}
 * ------------------------------------------------------------
*/
export const fetchContentCard = createAction(FETCH_CONTENT_CARD_REQUEST, (id) => {
  return id;
});

const fetchContentCardSucceeded = createAction(FETCHING_CONTENT_CARD_SUCCEEDED, response => {
  return response;
})

const fetchContentCardFailed = createAction(FETCHING_CONTENT_CARD_FAILED, error => {
  return error;
})

function* fetchContentCardSaga(action) {
  const id = action.payload;

  let url = buildUrl(CONTENT_CARD_BASE_URL, {
    path: id
  });

  const fetchContentCardAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchContentCardAPI);
    if (response) {
      yield put(fetchContentCardSucceeded(response));
    }
  } catch (error) {
    yield put(fetchContentCardFailed(error));
  }
}

/**
 * ------------------------------------------------------------
 * Invalidate Content cards
 * ------------------------------------------------------------
*/
export const invalidateContentCard = createAction(INVALIDATE_CONTENT_CARD);

export default function* contentCardsSaga() {
  yield takeEvery(FETCH_CONTENT_CARDS_REQUEST, fetchContentCardsSaga);
  yield takeEvery(FETCH_CONTENT_CARD_REQUEST, fetchContentCardSaga);
}